export default __webpack_public_path__ + "static/henry-508dfefa45c6fe93a0f0656b5b7aec24.jpg";